import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import Responsive from '../../../../../ui/utils/Responsive';

export const StyledDetailsFormSection = styled.div`
	padding-bottom: 32px;

	hr {
		margin-bottom: 32px;
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		padding-bottom: 16px;

		h3 {
			font-size: 22px;
			margin-bottom: 8px;
		}

		hr {
			margin-bottom: 24px;
		}
	}
`;

interface IDetailsFormSectionProps {
	title?: string;
	children?: ReactNode;
}

export const DetailsFormSection = ({
	title,
	children,
}: IDetailsFormSectionProps) => (
	<StyledDetailsFormSection>
		{title && <h3>{title}</h3>}
		<hr />
		{children}
	</StyledDetailsFormSection>
);
